import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';

function CustomTable() {
  const { t } = useTranslation('common');
  const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
  ];

  const [openPopoverId, setOpenPopoverId] = useState(null);

  const handleToggle = (rowId, nextShow) => {
    setOpenPopoverId(nextShow ? rowId : null); // Set the id if opened, null if closed
  };
  return (
    <>
      <h5>Scrollable Table</h5>
      <div className="table-responsive mb-4">
        <table id="demoTable" className="table common-custom-table">
          <thead>
            <tr>
              <th className="w-50px">
                <div className="common-checkbox">
                  <input type="checkbox" id="checkall" name="demo 1" value="demo 1" />
                  <label htmlFor="checkall" className="chklabel">
                    <span className="sr-only">{t('CHECK_BOX_LABEL.I AGREE')}</span>
                  </label>
                </div>
              </th>
              <th className="w-50px first-fix-col">
                <button className="btn-up-down" type="button" aria-label="Expand/Collapse">
                  <span className="icon-new-down-arrow-icon " />
                </button>
              </th>
              <th className="w-200px">Colourway</th>
              <th>Size</th>
              <th>Length</th>
              <th className="w-300px">Test 1</th>
              <th className="w-300px">Test 2</th>
              <th>Quantity</th>
              <th>Consumption</th>
              <th className="w-120px last-fix-col">UoM</th>
              <th className="w-150px" />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="common-checkbox">
                  <input type="checkbox" id="check2" name="demo 1" value="demo 1" />
                  <label htmlFor="check2" className="chklabel">
                    <span className="sr-only">{t('CHECK_BOX_LABEL.I AGREE')}</span>
                  </label>
                </div>
              </td>
              <td className="first-fix-col">
                <button className="btn-up-down" type="button" aria-label="Expand/Collapse">
                  <span className="icon-new-down-arrow-icon " />
                </button>
              </td>
              <td>Midnight Ocean</td>
              <td>S - M - L</td>
              <td>Regular</td>
              <td>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using
                Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like
                readable English.{' '}
              </td>
              <td>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using
                Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like
                readable English.{' '}
              </td>
              <td>15</td>
              <td>
                <input type="text" className="form-control" />
              </td>

              <td className="last-fix-col">
                <div className="common-react-select">
                  <Select options={options} className="common-select" classNamePrefix="common-select" />
                </div>
              </td>
              <td>
                <div className="table-action-container">
                  <button type="button" aria-label="Edit" className="btn p-0">
                    <span className="icon-Edit-1 f-20" />
                  </button>
                  <button type="button" aria-label="Edit" className="btn p-0">
                    <span className="icon-Delete f-20" />
                  </button>
                  <button type="button" className="btn p-0">
                    <OverlayTrigger
                      placement="left"
                      trigger="click"
                      rootClose
                      onToggle={(nextShow) => handleToggle(1, nextShow)}
                      overlay={
                        <Popover className="table-action-popup">
                          <Popover.Content>
                            <ul className="two-col">
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Eye-Open-1 f-20" />
                                  <span className="text">Show/Hide</span>
                                </button>
                              </li>
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Library f-20" />
                                  <span className="text">Library</span>
                                </button>
                              </li>
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Preview-Document f-20" />
                                  <span className="text">Preview</span>
                                </button>
                              </li>
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Download1 f-20" />
                                  <span className="text">Download</span>
                                </button>
                              </li>
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Information f-20" />
                                  <span className="text">Info</span>
                                </button>
                              </li>
                            </ul>
                          </Popover.Content>
                        </Popover>
                      }
                    >
                      <i className={`icon ${openPopoverId === 1 ? 'icon-close f-20' : 'icon-More f-20'}`} />
                    </OverlayTrigger>
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="common-checkbox">
                  <input type="checkbox" id="check2" name="demo 1" value="demo 1" />
                  <label htmlFor="check2" className="chklabel">
                    <span className="sr-only">{t('CHECK_BOX_LABEL.I AGREE')}</span>
                  </label>
                </div>
              </td>
              <td className="first-fix-col">
                <button className="btn-up-down" type="button" aria-label="Expand/Collapse">
                  <span className="icon-new-down-arrow-icon " />
                </button>
              </td>
              <td>Midnight Ocean</td>
              <td>S - M - L</td>
              <td>Regular</td>
              <td>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using
                Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like
                readable English.{' '}
              </td>
              <td>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using
                Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like
                readable English.{' '}
              </td>
              <td>15</td>
              <td>
                <input type="text" className="form-control" />
              </td>

              <td className="last-fix-col">
                <div className="common-react-select">
                  <Select options={options} className="common-select" classNamePrefix="common-select" />
                </div>
              </td>
              <td>
                <div className="table-action-container">
                  <button type="button" aria-label="Edit" className="btn p-0">
                    <span className="icon-Edit-1 f-20" />
                  </button>
                  <button type="button" aria-label="Edit" className="btn p-0">
                    <span className="icon-Delete f-20" />
                  </button>
                  <button type="button" className="btn p-0">
                    <OverlayTrigger
                      placement="left"
                      trigger="click"
                      rootClose
                      onToggle={(nextShow) => handleToggle(2, nextShow)}
                      overlay={
                        <Popover className="table-action-popup">
                          <Popover.Content>
                            <ul>
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Eye-Open-1 f-20" />
                                  <span className="text">Show/Hide</span>
                                </button>
                              </li>
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Library f-20" />
                                  <span className="text">Library</span>
                                </button>
                              </li>
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Preview-Document f-20" />
                                  <span className="text">Preview</span>
                                </button>
                              </li>
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Download1 f-20" />
                                  <span className="text">Download</span>
                                </button>
                              </li>
                              <li>
                                <button type="button" aria-label="Library" className="btn">
                                  <span className="icon icon-Information f-20" />
                                  <span className="text">Info</span>
                                </button>
                              </li>
                            </ul>
                          </Popover.Content>
                        </Popover>
                      }
                    >
                      <i className={`icon ${openPopoverId === 2 ? 'icon-close f-20' : 'icon-More f-20'}`} />
                    </OverlayTrigger>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h5>Normal Table</h5>
      <div className="table-responsive">
        <table className="table common-custom-table">
          <thead>
            <tr>
              <th className="w-50px">
                <div className="common-checkbox">
                  <input type="checkbox" id="checkall" name="demo 1" value="demo 1" />
                  <label htmlFor="checkall" className="chklabel">
                    <span className="sr-only">{t('CHECK_BOX_LABEL.I AGREE')}</span>
                  </label>
                </div>
              </th>
              <th className="w-50px">
                <button className="btn-up-down" type="button" aria-label="Expand/Collapse">
                  <span className="icon-new-down-arrow-icon " />
                </button>
              </th>
              <th className="w-200px">Colourway</th>
              <th>Size</th>
              <th>Length</th>

              <th>Quantity</th>
              <th>Consumption</th>
              <th className="w-120px last-fix-col">UoM</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="common-checkbox">
                  <input type="checkbox" id="check2" name="demo 1" value="demo 1" />
                  <label htmlFor="check2" className="chklabel">
                    <span className="sr-only">{t('CHECK_BOX_LABEL.I AGREE')}</span>
                  </label>
                </div>
              </td>
              <td className="first-fix-col">
                <button className="btn-up-down" type="button" aria-label="Expand/Collapse">
                  <span className="icon-new-down-arrow-icon " />
                </button>
              </td>
              <td>Midnight Ocean</td>
              <td>S - M - L</td>
              <td>Regular</td>

              <td>15</td>
              <td>
                <input type="text" className="form-control" />
              </td>

              <td>
                <div className="common-react-select">
                  <Select options={options} className="common-select" classNamePrefix="common-select" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="table-responsive">
        <table className="table custom-table">
          <thead>
            <tr>
              <th>
                {t('CUSTOM_TABLE.GRADING_NAME')}
                <i className="fa fa-sort ml-2" />
              </th>
              <th>
                {t('CUSTOM_TABLE.BRAND')}
                <i className="fa fa-sort-desc ml-2" />
              </th>
              <th>
                {t('CUSTOM_TABLE.CATEGORIES')}
                <i className="fa fa-sort-up ml-2" />
              </th>
              <th>{t('CUSTOM_TABLE.SIZE_RANGE')}</th>
              <th>{t('CUSTOM_TABLE.STATUS')}</th>
              <th className="w-action">{t('CUSTOM_TABLE.ACTION')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{t('CUSTOM_TABLE.TEST_NAME')}</td>
              <td>{t('CUSTOM_TABLE.BRANCH_TEST')}</td>
              <td>{t('CUSTOM_TABLE.TEST_CATEGORY')}</td>
              <td>{t('CUSTOM_TABLE.SIZE-TEST')}</td>
              <td>{t('CUSTOM_TABLE.STATUSS')}</td>
              <td>
                <button className="btn-tbl-action">
                  <span className="icon-edit" />
                </button>
                <button className="btn-tbl-action">
                  <span className="icon-delete" />
                </button>
                <button className="btn-tbl-action">
                  <span className="icon-copy" />
                </button>
              </td>
            </tr>
            <tr>
              <td>{t('CUSTOM_TABLE.TEST_NAME')}</td>
              <td>{t('CUSTOM_TABLE.BRANCH_TEST')}</td>
              <td>{t('CUSTOM_TABLE.TEST_CATEGORY')}</td>
              <td>{t('CUSTOM_TABLE.SIZE-TEST')}</td>
              <td>{t('CUSTOM_TABLE.STATUS')}</td>
              <td>
                <button className="btn-tbl-action">
                  <span className="icon-edit" />
                </button>
                <button className="btn-tbl-action">
                  <span className="icon-delete" />
                </button>
                <button className="btn-tbl-action">
                  <span className="icon-copy" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default CustomTable;
